import { render } from "./NewLeads.vue?vue&type=template&id=1aa39868&ts=true"
import script from "./NewLeads.vue?vue&type=script&lang=ts"
export * from "./NewLeads.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__